import React from 'react';
import PropTypes from 'prop-types';
import TTLAsyncProxy from "../../common/TTLAsyncProxy";
import _ from 'lodash';
import RoleRender from "../RoleRender";
import Utils from "../../common/Utils";
import {UserRoles} from "../../common/Constants";

export const DenyView = ({ permissions , roles }) => {

    return <div className="text-center p-5">
        <h6 className="error-label">Permission Denied</h6>
        <p><i className="fa fa-smile-o fa-3x"/></p>
        <p>Sorry, you do not have enough permissions</p>
    </div>
};

export const hasAllPermissions = (userPermissions, checkPermissions) => {
    if (userPermissions[0] === "*")
        return true;

    for (let i = 0, len = checkPermissions.length; i < len; i++) {
        if (!userPermissions.includes(checkPermissions[i])) {
            return false;
        }
    }

    return true;
};


export const hasAnyPermission = (userPermissions, checkPermissions) => {
    if (userPermissions[0] === "*")
        return true;

    for (let i = 0, len = checkPermissions.length; i < len; i++) {
        if (userPermissions.includes(checkPermissions[i])) {
            return true;
        }
    }

    return false;
};


export const hasDepartment = (user,department) => {

    if(user.role !== UserRoles.Admin || _.isNil(user.admin.departments)){
        return false;
    }

    return department.every(d => user.admin.departments.includes(d));
};

const PermissionRender = ({ superUser  , children , required  , optional , exclude , roles , departments , component }) => {

    const proxy = TTLAsyncProxy.getInstance();

    const renderComponent = () => {
        let Component = component;
        return Component
            ?  <Component permissions={{ required, optional , exclude }}/> : null;
    };

    const user = proxy.getUserInfo();

    //  pass for super user
    if(proxy.isSuperUser())
        return children;

    if (superUser || (!_.isNil(departments) && !hasDepartment(user,departments))) {
        return renderComponent();
    }

    const userPermissions = user.permissions || [];
    if (
        (_.isArray(required) &&
            required.length > 0 &&
            !hasAllPermissions(userPermissions, required)) ||
        (_.isArray(optional) &&
            optional.length > 0 &&
            !hasAnyPermission(userPermissions, optional))  ||
        (_.isArray(exclude) && exclude.length > 0 &&
           hasAnyPermission(userPermissions,exclude))
    ) {
        return renderComponent();
    }

    return roles ? (
        <RoleRender role={roles} component={component}>
            {children}
        </RoleRender>
    ) : (
        children
    );

};

PermissionRender.propTypes = {
    superUser: PropTypes.bool,
    required: PropTypes.arrayOf(PropTypes.string),
    optional: PropTypes.arrayOf(PropTypes.string),
    roles: PropTypes.arrayOf(PropTypes.string),
    departments: PropTypes.arrayOf(PropTypes.string),
    exclude: PropTypes.arrayOf(PropTypes.string),
    component: PropTypes.any
};

PermissionRender.defaultProps = {
    component: null
};


export default PermissionRender;



// WEBPACK FOOTER //
// ./src/components/PermissionRender/PermissionRender.js